<template>
  <layout-main-inner title="散茶批次">
    <layout-card-wrap
      v-loading="loading"
      hasHeaderSlot>
      <template slot="form">
        <!-- <assign-ent-select
          v-if="userPermission.SUPERVISE || userPermission.OPERATE"
          v-model="config.vendorId"
          immediate
          style="margin-right: 10px"
          :option="{}"
          :callback="() => {handleCurrentChange(1)}" /> -->
        <!-- <el-input placeholder="请输入商品名称"
          v-model="config.productName"
          style="width: 200px">
          <el-button slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input> -->
        <ent-product-auto-select
          v-model="config.productId"
          :productTypes="[3]"
          :callback="() => {handleCurrentChange(1)}" />
        <el-input
          v-model="config.batchCode"
          placeholder="请输入散茶批次号"
          clearable=""
          style="width: 200px;margin-left: 10px;"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="批次号"
          :resizable="false"
          width="200">
          <template slot-scope="{row}">
            {{ row.batchCode }}
          </template>
        </el-table-column>
        <el-table-column
          label="散茶名称"
          :resizable="false">
          <template slot-scope="{row}">
            {{ row.productName }}<span v-if="row.productNameRemark">({{ row.productNameRemark }})</span>
          </template>
        </el-table-column>
        <el-table-column
          label="仓库"
          :resizable="false"
          width="120"
          prop="warehouseNo">
          <template slot-scope="{row}">
            {{ row.warehouseNo | warehouseName() }}
          </template>
        </el-table-column>
        <el-table-column
          label="数量"
          :resizable="false"
          width="140"
          prop="stockDesc">
        </el-table-column>
        <el-table-column
          label="创建时间"
          :resizable="false"
          width="140">
          <template slot-scope="{row}">
            {{ row.createdTime | dateformat() }}
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <pagination-new
          v-model="config"
          :total="total"
          :fetch="fetchList" />
      </template>
    </layout-card-wrap>
  </layout-main-inner>
</template>

<script>
// import AssignEntSelect from '@/components/business/assign-ent-select.vue'
import EntProductAutoSelect from '@/components/business/ent-product-auto-select.vue'
import { mapState } from 'vuex'
export default {
  name: 'LooseTeaList',
  components: { EntProductAutoSelect },
  data() {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        productId: null,
        vendorId: null,
        batchCode: null,
        productTypes: [2, 3]
      },
      list: [],
      total: 0,
      current: {}
    }
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission,
      query: state => state.common.query,
      userDetail: state => state.account.userDetail
    })
  },
  created() {
    if (this.query) {
      this.config = {
        ...this.config,
        ...this.query
      }
    }
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.commit('common/setQuery', this.config)
      this.$store.dispatch('batch/getbatchs', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
